import React, { useState, useEffect, useMemo } from 'react';

interface DocListShowMoreBtnProps {
  selectedTag: boolean;
  updateSelectedTag: (val: boolean) => void;
  text: string;
  listLength: number;
}

export const DocListShowMoreBtn = ({
  selectedTag,
  updateSelectedTag,
  text,
  listLength,
}: DocListShowMoreBtnProps) => {
  const [isVisible, setIsVisible] = useState(0);
  const [showMoreClick, setShowMoreClick] = useState(false);
  const offset = 8;
  const defaultOffset = 4;

  useEffect(() => {
    if (selectedTag) {
      setIsVisible(0);
      setShowMoreClick(false);
    }
  }, [selectedTag]);

  const handleShowMore = () => {
    const offsetNew = isVisible + offset;
    const blocks = document.querySelectorAll(
      '[data-related-block="documentlist' + offsetNew + '"]'
    );
    blocks?.forEach((element) => {
      element.classList.remove('hidden');
    });
    setIsVisible((oldVal) => oldVal + offset);

    if (selectedTag) updateSelectedTag(false);
    setShowMoreClick(true);
  };

  const canShowMore = useMemo(() => {
    let show = false;
    if (defaultOffset < listLength) {
      if (showMoreClick) {
        if (offset < listLength && (isVisible == 0 || isVisible + defaultOffset < listLength))
          show = true;
      } else if (isVisible == 0 || isVisible + defaultOffset < listLength) {
        show = true;
      }
    }
    return show;
  }, [isVisible, listLength]);

  return canShowMore ? (
    <div className='l-show-more-btn'>
      <button className='c-button is-primary is-medium is-upper-case' onClick={handleShowMore}>
        {text}
      </button>
    </div>
  ) : null;
};
